import React, { useState } from 'react'
import Select from '@material-ui/core/Select'
import FormControl, { FormControlProps } from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import { FieldRenderProps } from 'react-final-form'
import { MenuItem, TextField } from '@material-ui/core'
import { injectIntl, WrappedComponentProps } from 'react-intl'

interface WrappedSelectProps extends FieldRenderProps<unknown> {
  label: string
  formControlProps: FormControlProps
}

const WrappedSelect = ({
  intl: { formatMessage },
  input: { name, value, onChange, ...restInput },
  meta,
  label,
  formControlProps,
  children,
  useSearch,
  items,
  ...rest
}: WrappedSelectProps & WrappedComponentProps) => {
  const [search, setSearch] = useState('')
  const showError =
    ((meta.submitError && !meta.dirtySinceLastSubmit) || meta.error) &&
    meta.touched

  const filteredItems = items?.filter(
    ({ name }: { name: string }) =>
      (name ?? '').toString().toLowerCase().includes(search) || search === '',
  )

  return (
    <FormControl {...formControlProps} error={showError}>
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <Select
        {...rest}
        name={name}
        onChange={onChange}
        onClose={() => setSearch('')}
        inputProps={restInput}
        value={value}
        MenuProps={{ getContentAnchorEl: null }}>
        {useSearch && (
          <MenuItem onKeyDown={event => event.stopPropagation()} button={false}>
            <TextField
              fullWidth
              placeholder={formatMessage({ id: 'search' })}
              value={search}
              onClick={event => event.stopPropagation()}
              onChange={({ target: { value } }) => setSearch(value)}
            />
          </MenuItem>
        )}
        {filteredItems?.map(
          ({ id, name }: { id: string; name: string }, index: number) =>
            name != null && (
              <MenuItem key={id ?? index} value={id ?? ''}>
                {name}
              </MenuItem>
            ),
        )}
        {children}
      </Select>
      {showError && (
        <FormHelperText>{meta.error || meta.submitError}</FormHelperText>
      )}
    </FormControl>
  )
}

export default injectIntl(WrappedSelect)
